import type { RootState } from 'types/root-state';

import { initialState } from './slice';
import { WindowTypes } from './types';

const selectDomain = (state: RootState) => state.spl.pageStore || initialState;

export const selectWindowType = (state: RootState) => selectDomain(state).windowType;
export const selectIsSmallScreen = (state: RootState) => selectDomain(state).isSmallScreen;
export const selectIsMobileScreen = (state: RootState) =>
	selectWindowType(state) === WindowTypes.mobile;

export const selectABVariant = (testName: string) => (state: RootState) =>
	selectDomain(state).abTesting[testName] || null;
